import ServiceMesaButton from './ServiceMesaButton';

const DEFAULT_LAYOUTS = [
  { x: 8, y: 12, w: 13, h: 12, shape: 'round', zone: 'entrada' },
  { x: 28, y: 12, w: 13, h: 12, shape: 'round', zone: 'entrada' },
  { x: 48, y: 12, w: 13, h: 12, shape: 'round', zone: 'entrada' },
  { x: 68, y: 12, w: 13, h: 12, shape: 'round', zone: 'entrada' },
  { x: 12, y: 42, w: 16, h: 12, shape: 'rect', zone: 'sala' },
  { x: 36, y: 42, w: 16, h: 12, shape: 'rect', zone: 'sala' },
  { x: 60, y: 42, w: 16, h: 12, shape: 'rect', zone: 'sala' },
  { x: 16, y: 72, w: 13, h: 12, shape: 'round', zone: 'fondo' },
  { x: 42, y: 72, w: 13, h: 12, shape: 'round', zone: 'fondo' },
  { x: 68, y: 72, w: 13, h: 12, shape: 'round', zone: 'fondo' }
];

function layoutFor(table, index) {
  return table.layout?.x != null ? table.layout : DEFAULT_LAYOUTS[index] || {
    x: 10 + (index % 4) * 22,
    y: 15 + Math.floor(index / 4) * 25,
    w: 14,
    h: 12,
    shape: 'round',
    zone: 'sala'
  };
}

export default function ServicePlano({ tables, selectedTable, onSelectTable }) {
  return (
    <section className="service-panel service-plano-panel">
      <div className="service-panel-head">
        <div>
          <h2>Plano de sala</h2>
          <p>Lectura rápida de actividad por mesa.</p>
        </div>
      </div>

      <div className="service-room-plan" aria-label="Plano operativo de sala">
        <div className="service-room-zone service-room-zone-bar">Barra / entrada</div>
        <div className="service-room-zone service-room-zone-floor">Sala</div>
        <div className="service-room-zone service-room-zone-back">Fondo</div>
        {tables.map((table, index) => (
          <ServiceMesaButton
            key={table._id}
            table={table}
            layout={layoutFor(table, index)}
            selected={selectedTable?._id === table._id}
            onSelect={onSelectTable}
          />
        ))}
      </div>
    </section>
  );
}
